import ReactGA from 'react-ga4';

// Replace 'G-XXXXXXXXXX' with your actual Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = 'G-ZM7645G37X';

export const initGA = () => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

export const logPageView = () => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};

export const logEvent = (category, action, label) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
};

export const logException = (description, fatal = false) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.exception({
      description: description,
      fatal: fatal,
    });
  }
}; 